module.exports = __webpack_public_path__ + "d4c598d80aee87936063649e89420426.pdf";